import { render } from "./HeaderPrincipal.vue?vue&type=template&id=c2c909c8&scoped=true"
import script from "./HeaderPrincipal.vue?vue&type=script&lang=js"
export * from "./HeaderPrincipal.vue?vue&type=script&lang=js"

import "./HeaderPrincipal.vue?vue&type=style&index=0&id=c2c909c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2c909c8"]])

export default __exports__